// import React, { createContext, useState } from 'react';

// export const RedirectContext = createContext();


// export const RedirectProvider = ({ children }) => {
//     const [redirectPath, setRedirectPath] = useState(null);

//     return (
//         <RedirectContext.Provider value={{ redirectPath, setRedirectPath }}>
//             {children}
//         </RedirectContext.Provider>
//     );
// };
// RedirectContext.js
import React, { createContext, useState } from 'react';
export const RedirectContext = createContext();
export const RedirectProvider = ({ children }) => {
    const [redirectPath, setRedirectPath] = useState(null);
    const [selectedState, setSelectedState] = useState(null); // Add selectedState
    return (
        <RedirectContext.Provider value={{
            redirectPath,
            setRedirectPath,
            selectedState,      // Provide selectedState
            setSelectedState    // Provide setSelectedState
        }}>
            {children}
        </RedirectContext.Provider>
    );
};



